import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function outcomes() {
  return (
    <section className="outcome p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              The <span>Outcomes?</span> 
            </h2>
            <p>
              We created the iOS version of the Parcheesi Cash available on the
              App Store for iPhone, macOS, and iPad. We exceeded the client’s
              expectations by considerable margins. The client was fascinated by
              the work of our UI/UX design team and the overall execution of the
              project.
            </p>
            <div className="outcome_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/outcomes.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1496}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default outcomes;
